'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analytics = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _analytics;

var _constant = require('./constant');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var analytics = exports.analytics = (_analytics = {}, (0, _defineProperty3.default)(_analytics, _constant.SET_MEETING_POINT_SUCCESS, function () {
  return { name: 'Set Meeting Point', category: 'Booking' };
}), (0, _defineProperty3.default)(_analytics, _constant.SEND_MESSAGE_SUCCESS, function () {
  return { name: 'Send Message', category: 'Booking' };
}), (0, _defineProperty3.default)(_analytics, _constant.ACTIVATE_BOOKING_SUCCESS, function () {
  return { name: 'Activate Booking (Null Message)', category: 'Booking' };
}), (0, _defineProperty3.default)(_analytics, _constant.OPEN_SWAP_LX, function (action, getState) {
  return action.active ? { name: 'Open Swap LX', category: 'Booking', bookingID: getState().booking.data._id } : null;
}), (0, _defineProperty3.default)(_analytics, _constant.REQUEST_SWAP_LX_SUCCESS, function (action) {
  return { name: 'Swap LX Requested', category: 'Booking', bookingID: action.id };
}), (0, _defineProperty3.default)(_analytics, _constant.CREATE_BOOKING, function (action) {
  return { name: 'Create Booking', category: 'Booking', bookingData: action.data };
}), (0, _defineProperty3.default)(_analytics, _constant.LOG_BOOKING_ACTION, function (action) {
  return { name: 'Press Action Button', category: 'Chat', action: action.action, providers: 'database' };
}), (0, _defineProperty3.default)(_analytics, _constant.LOG_CLICK_BOOK_NOW_AND_SAVE, function () {
  return { name: 'Press Book now and Save on mobile', category: 'Booking', providers: 'database' };
}), _analytics);


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/booking/analytics.js
// module id = 1701
// module chunks = 47